export const COMPANY_NAME = 'Vientiane Traffic';

export const COMPANY_NAME_FULL =
  'ບໍລິສັດ ວຽງຈັນທຣາບຟິກ ຈຳກັດ Vientiane Traffic Co.,Ltd';

export const TAGLINE = 'Quality services are our specialty.';

export const HERO_EYEBROW = 'Road Safety Solutions';

export const HERO_DESCRIPTION =
  'We deliver road safety, signage, and marking solutions built to international standards. Our commitment to quality ensures every project meets the highest safety and durability requirements.';

export const FACEBOOK_URL =
  'https://www.facebook.com/profile.php?id=100057389562049&mibextid=LQQJ4d';

export const WHATSAPP_URL = 'https://wa.link/1hha8f';

export const YOUTUBE_URL = 'https://www.youtube.com/@VientianeTraffic';

export const INSTAGRAM_URL = 'https://www.instagram.com/vientianetraffic/';

export const SOCIAL_GRID_LINKS = [
  { id: 'facebook', label: 'Facebook', icon: 'fab fa-facebook', href: FACEBOOK_URL },
  { id: 'whatsapp', label: 'WhatsApp', icon: 'fab fa-whatsapp', href: WHATSAPP_URL },
  { id: 'youtube', label: 'YouTube', icon: 'fab fa-youtube', href: YOUTUBE_URL },
  { id: 'instagram', label: 'Instagram', icon: 'fab fa-instagram', href: INSTAGRAM_URL },
];

export const CONTACT_EMAILS = [
  'khamphone_k@vientianetraffic.com',
  'info@vientianetraffic.com',
];

export const CONTACT_PHONES = ['+856 20 78 911 599', '+856 20 55 424 774'];

export const CONTACT_ADDRESS =
  'Xingda village, Saysettha district, Vientiane capital, Lao PDR';

export const MAP_SHARE_URL =
  'https://www.google.com/maps/place/%E0%BA%9A%E0%BB%8D%E0%BA%A5%E0%BA%B4%E0%BA%AA%E0%BA%B1%E0%BA%94+%E0%BA%A7%E0%BA%BD%E0%BA%87%E0%BA%88%E0%BA%B1%E0%BA%99%E0%BA%97%E0%BA%A3%E0%BA%B2%E0%BA%9A%E0%BA%9F%E0%BA%B4%E0%BA%81+%E0%BA%88%E0%BA%B3%E0%BA%81%E0%BA%B1%E0%BA%94+Vientiane+Traffic+Co.,Ltd/@17.9387727,102.6774459,521m/data=!3m1!1e3!4m6!3m5!1s0x312467b7a6072703:0xbe90eb5dfb51722c!8m2!3d17.9397483!4d102.6773421!16s%2Fg%2F11vxgrx88v?entry=ttu';

export const MAP_EMBED_URL =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.574845266584!2d102.6747618!3d17.9397534!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x312467b7a6072703%3A0xbe90eb5dfb51722c!2sVientiane%20Traffic%20Co.%2C%20Ltd!5e0!3m2!1sen!2sla!4v1718900000000!5m2!1sen!2sla';

export const IMAGE_BASE = '/images/content image';
